import { createContext } from "react";
import { useModal } from "hooks/useDialog";
import { CustomModalFunc } from "cointr";

export const DialogContext = createContext<CustomModalFunc>(null);

export default function DialogProvider(props: any) {
  const [modal, contextHolder] = useModal();
  return (
    <DialogContext.Provider value={modal}>
      {props.children}
      {contextHolder}
    </DialogContext.Provider>
  );
}
